<div class="schedule-pay-section">
  <div class="col-xs-12 schpay_tablesection" [ngClass]="{'schedule_data_true': schedulePayData && schedulePayData.length > 0, 'no_schedule_data': !(schedulePayData && schedulePayData.length > 0)}">
    @if (schedulePayData && schedulePayData.length > 0 ) {
      <div class="schedule-pay-detail-section">
        <div class="col-7 schpay_header">{{"schedulepay.title" | cxTranslate}}
          <div class="schpay_subheader">{{"schedulepay.paymethodtitle" | cxTranslate}}<i class="fa-regular fa-circle-question sch_pay_tooltip"><span class="sch_pay_tooltiptext" [innerHTML]="'schedulepay.paymethodtooltip' | cxTranslate"></span></i></div>
        </div>
        <div class="col-12  all-invoices">
          <div class="all-invoices-link"><a [routerLink]="['/financial-dashboard/all-invoices']">{{"schedulepay.allinvoicetxt" | cxTranslate}}</a></div>
          <div class="global_blackarrow all_Invoices_link_Arrow"></div>
        </div>
        <div class="schpay_table_container">
          <table mat-table [dataSource]="schedulePayment" id="schedulepay" matSort multiTemplateDataRows class="mat-elevation-z8">
            <ng-container matColumnDef="scheduledDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true" class="schPay_Date">{{"schedulepay.schdatelabel" | cxTranslate}}
                @if (schedulePayment.sort?.active === 'scheduledDate') {
                  <span>
                    <img [ngClass]="{'rotated': schedulePayment.sort?.direction === 'desc'}" src="assets/images/sort_grey.png"/>
                  </span>
                }
              </th>
              <td mat-cell *matCellDef="let element"> {{element.scheduledDate}} </td>
            </ng-container>
            <ng-container matColumnDef="dueDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true" class="schPay_Due_Date">{{"schedulepay.duedatelabel" | cxTranslate}}
                @if (schedulePayment.sort?.active === 'dueDate') {
                  <span>
                    <img [ngClass]="{'rotated': schedulePayment.sort?.direction === 'desc'}" src="assets/images/sort_grey.png"/>
                  </span>
                }
              </th>
              <td mat-cell *matCellDef="let element"> {{element.dueDate}} </td>
            </ng-container>
            <ng-container matColumnDef="invoiceAmount">
              <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true" class="schPay_Invoice_Amount">{{"schedulepay.ccpaymentlabel" | cxTranslate}}
                @if (schedulePayment.sort?.active === 'invoiceAmount') {
                  <span>
                    <img [ngClass]="{'rotated': schedulePayment.sort?.direction === 'desc'}" src="assets/images/sort_grey.png"/>
                  </span>
                }
              </th>
              <td mat-cell *matCellDef="let element"> @if (!element.hasCredits) {
                {{element.invoiceAmount | currency:'USD':'symbol'}}
                }@if (element.hasCredits) {
                {{element.invoiceAmount | currency:'USD':'symbol'}}
              }
              @if (element.hasCredits) {
                <i class="fa-regular fa-circle-question sch_pay_credit_tooltip"><span class="sch_pay_credit_tooltiptext">{{element.creditsTotal | currency:'USD':'symbol'}} in credits have been applied to pay your remaining balance of {{getActualAmount(element) | currency:'USD':'symbol'}}</span></i>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="paymentMethod">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true" class="schPay_Pay_Method">{{"schedulepay.paymentmethodlabel" | cxTranslate}}
              @if (schedulePayment.sort?.active === 'paymentMethod') {
                <span>
                  <img [ngClass]="{'rotated': schedulePayment.sort?.direction === 'desc'}" src="assets/images/sort_grey.png"/>
                </span>
              }
            </th>
            <td mat-cell *matCellDef="let element">
              @if (element.cardType == '1') {
                <img width="75" class="image" src="../../assets/images/Visa_icon.png"
                  alt="Visa">
              }
              @if (element.cardType == '2') {
                <img width="75" class="image" src="../../assets/images/amex_icon.png"
                  alt="American Express">
              }
              @if (element.cardType == '3') {
                <img width="75" class="image" src="../../assets/images/master_icon.png"
                  alt="MasterCard">
              }
              @if (element.cardType == '128') {
                <img width="75" class="image" src="../../assets/images/Discover_icon.png"
                  alt="Discover">
              }
              **{{element.cardNumber.slice(-4)}}
            </td>
          </ng-container>
          <ng-container matColumnDef="invoiceNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true" class="schPay_Invoice_Num">{{"schedulepay.invoicenolabel" | cxTranslate}}
              @if (schedulePayment.sort?.active === 'invoiceNumber') {
                <span>
                  <img [ngClass]="{'rotated': schedulePayment.sort?.direction === 'desc'}" src="assets/images/sort_grey.png"/>
                </span>
              }
            </th>
            <td mat-cell *matCellDef="let element"> {{element.invoiceNumber}} </td>
          </ng-container>
          <ng-container matColumnDef="reschedule">
            <th mat-header-cell *matHeaderCellDef ></th>
            <td mat-cell *matCellDef="let element">@if (!element.isExpanded && element.paymentStatus != 'FAILED') {
              <button class="sch_reschedule_button" [disabled]="!element.modificationAllowed" (click)="openRescheduleSection(element)">{{"schedulepay.reschedulelabel" | cxTranslate}}</button>
            }</td>
          </ng-container>
          <ng-container matColumnDef="cancel">
            <th mat-header-cell *matHeaderCellDef ></th>
            <td mat-cell *matCellDef="let element" [ngClass]="{'save_btn_class':element.isExpanded}">@if (!element.isExpanded && element.paymentStatus != 'FAILED') {
              <button class="sch_cancel_button" data-bs-toggle="modal" data-bs-target="#schpay_cancelmodal" (click)="openCancelPopup(element)">{{"schedulepay.cancellabel" | cxTranslate}}</button>
              }@if (element.isExpanded) {
              <button [disabled]="!dateInput || !checkValidDate(dateInput,element.dueDate)" (click)="reSchedulePayment(element)" class="schpay_savebtn">{{"schedulepay.savelabel" | cxTranslate}} <div class="schpay_saveicon"></div></button>
            }</td>
          </ng-container>
          <ng-container matColumnDef="viewInvoice">
            <th mat-header-cell *matHeaderCellDef ></th>
            <td mat-cell *matCellDef="let element" [ngClass]="{'view-details':!element.isExpanded,'close_icon_class': element.isExpanded}">@if (element.isExpanded) {
              <div class="reschedule_closeicon" (click)="closeReschedule(element)"></div>
              }@if (!element.isExpanded) {
              <a [routerLink]="['/financial-dashboard/all-invoices']" [queryParams]="{season:element.season,invoice:element.invoiceNumber}">{{"schedulepay.viewinvlabel" | cxTranslate}}<div class="global_blackarrow"></div></a>
            }</td>
          </ng-container>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" class="desktop_row"></tr>
          <tr *matRowDef="let row ;columns:[]"  class="expanded-row">
            @if (row.isExpanded) {
              <td [attr.colspan]="8">
                <div class="resSchedule_Container">
                  <div class="sch_ReschedulePay">{{"schedulepay.reschedulepay" | cxTranslate}}</div>
                  <div class="newPay_Date">{{"schedulepay.newpayDate" | cxTranslate}}
                    <i class="fa-regular fa-circle-question resch_pay_tooltip"><span class="resch_pay_tooltiptext">{{"schedulepay.reschpaytooltiptxt" | cxTranslate}}</span></i></div>
                    <form #dateForm="ngForm">
                      <mat-form-field class="mat-focused">
                        <input matInput maxlength="10"  (keypress)="allowNumbersOnly($event)" [matDatepicker]="picker" name="schdate" (input)="maskInputDate($event)" [(ngModel)]="dateInput" placeholder="MM/DD/YYYY" [min]="today" [max]="getFormattedDueDate(row.dueDate)" #date="ngModel" [ngClass]="date?.invalid && date?.dirty && !isFieldFocused(date) ? 'invalid-date':''">
                        <mat-datepicker-toggle matIconPrefix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                        @if (date.invalid && date?.dirty && !isFieldFocused(date)) {
                          <span class="glyphicon glyphicon-exclamation-sign"></span>
                        }
                      </mat-form-field>
                      <div class="promptpay_text">{{"schedulepay.paymessage1" | cxTranslate}}<span>{{row.dueDate}}</span> {{"schedulepay.paymessage2" | cxTranslate}}</div>
                      @if (date?.invalid && date?.dirty && !isFieldFocused(date)) {
                        <div class="sch-pay-error-text">
                          @if (date?.errors) {
                            <p>{{"schedulepay.paymessage3" | cxTranslate}}{{row.dueDate}}</p>
                          }
                        </div>
                      }
                    </form>
                  </div>
                </td>
              }
              @if (row.paymentStatus === 'FAILED') {
                <td colspan="8">
                  <div class="payment-failed-section">
                    <div class="pay-fail-title"><span class="glyphicon glyphicon-exclamation-sign"></span>{{"schedulepay.payfailed" | cxTranslate}}</div>
                    <div class="pay_fail_text"><a [routerLink]="['/financial-dashboard/all-invoices']" [queryParams]="{season:row.season,invoice:row.invoiceNumber}">{{"schedulepay.viewinvoicelink" | cxTranslate}}</a>{{"schedulepay.payfailedmsg" | cxTranslate}}<br/> <a href="mailto:usainc.accountsreceivable@seqirus.com" target="_blank">usainc.accountsreceivable&#64;seqirus.com</a> or <a href="tel:866-434-1115">866-434-1115</a>.
                    <button class="global_greybtn new_pay_button" [routerLink]="['/financial-dashboard/all-invoices']" [queryParams]="{season:row.season,invoice:row.invoiceNumber}">{{"schedulepay.newpaytxt" | cxTranslate}}</button></div>
                  </div>
                </td>
              }
            </tr>
            <tr mat-header-row *matHeaderRowDef="displayedColumns" class="desktop_header"></tr>
          </table>
          <!-- Mobile view table-->
          <table mat-table [dataSource]="schedulePayment" id="schedulepay_mobile_table" matSort multiTemplateDataRows class="mat-elevation-z8 d-lg-none">
            <ng-container matColumnDef="combined">
              <th class="schedulepaymentheader d-none" mat-header-cell *matHeaderCellDef> Scheduled payments Data </th>
              <td mat-cell *matCellDef="let element" class="combined_mobile_table">
                <div class="payment_table" [ngClass]="{'pay_failed': element.paymentStatus == 'FAILED'}">
                  <!--Scheduled Date-->
                  <div class="mobile_payment_table">
                    <div class="table_header">{{"schedulepay.schdatelabel" | cxTranslate}}</div>
                    <div class="table_value">{{element.scheduledDate}} </div>
                  </div>
                  <!--Due Date-->
                  <div class="mobile_payment_table">
                    <div class="table_header">{{"schedulepay.duedatelabel" | cxTranslate}}</div>
                    <div class="table_value">{{element.dueDate}} </div>
                  </div>
                  <!--Credit Card Payment-->
                  <div class="mobile_payment_table">
                    <div class="table_header">{{"schedulepay.ccpaymentlabel" | cxTranslate}}</div>
                    <div class="table_value">{{element.invoiceAmount | currency:'USD':'symbol'}}
                      @if (element.hasCredits) {
                        <i class="fa-regular fa-circle-question sch_pay_credit_tooltip"><span class="sch_pay_credit_tooltiptext">{{element.creditsTotal | currency:'USD':'symbol'}} in credits have been applied to pay your remaining balance of {{getActualAmount(element) | currency:'USD':'symbol'}}</span></i>
                      }
                    </div>
                  </div>
                  <!--Payment Method-->
                  <div class="mobile_payment_table">
                    <div class="table_header">{{"schedulepay.paymentmethodlabel" | cxTranslate}}</div>
                    <div class="table_value">
                      @if (element.cardType == '1') {
                        <img width="38" class="image" src="../../assets/images/Visa_icon.png"
                          alt="Visa">
                      }
                      @if (element.cardType == '2') {
                        <img width="38" class="image" src="../../assets/images/amex_icon.png"
                          alt="American Express">
                      }
                      @if (element.cardType == '3') {
                        <img width="38" class="image" src="../../assets/images/master_icon.png"
                          alt="MasterCard">
                      }
                      @if (element.cardType == '128') {
                        <img width="38" class="image" src="../../assets/images/Discover_icon.png"
                          alt="Discover">
                      }
                      **{{element.cardNumber.slice(-4)}}
                    </div>
                  </div>
                  <!--Invoice #-->
                  <div class="mobile_payment_table">
                    <div class="table_header">{{"schedulepay.invoicenolabel" | cxTranslate}}</div>
                    <div class="table_value">{{element.invoiceNumber}} </div>
                  </div>
                  <!--Schedule cancel invoice Link outer wrapper-->
                  <div class="outer_wrapper">
                    <!-- Schudule and cancel button container-->
                    @if (!element.isExpanded && element.paymentStatus != 'FAILED') {
                      <div class="schedule_cancel_wrapper">
                        <div class="mobile_payment_table reschedule_btn">
                          @if (!element.isExpanded && element.paymentStatus != 'FAILED') {
                            <div class="table_value"><button class="sch_reschedule_button" [disabled]="!element.modificationAllowed" (click)="openRescheduleSection(element)">{{"schedulepay.reschedulelabel" | cxTranslate}}</button></div>
                          }
                        </div>
                        <div class="mobile_payment_table cancel_btn">
                          @if (!element.isExpanded && element.paymentStatus != 'FAILED') {
                            <div class="table_value"><button class="sch_cancel_button" data-bs-toggle="modal" data-bs-target="#schpay_cancelmodal" (click)="openCancelPopup(element)">{{"schedulepay.cancellabel" | cxTranslate}}</button></div>
                          }
                          <div class="table_value" ></div>
                        </div>
                      </div>
                    }
                    <!-- View Invoice Link-->
                    @if (element.paymentStatus != 'FAILED') {
                      <div class="view_invoice_wrapper">
                        <div class="table_value" [ngClass]="{'view-details-mobile':!element.isExpanded}">
                          @if (!element.isExpanded) {
                            <div class="invoice_Link_isExpanded">
                              <a [routerLink]="['/financial-dashboard/all-invoices']" [queryParams]="{season:element.season,invoice:element.invoiceNumber}">{{"schedulepay.viewinvlabel" | cxTranslate}}</a>
                              <div class="global_blackarrow"></div>
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                  <div class="mobile_payment_table_savebtn">
                    @if (element.isExpanded) {
                      <div class="table_value save_btn"><button [ngClass]="!dateInput || !checkValidDate(dateInput,element.dueDate)?'disable_save':''" [disabled]="!dateInput || !checkValidDate(dateInput,element.dueDate)" (click)="reSchedulePayment(element)" class="schpay_savebtn">{{"schedulepay.savelabel" | cxTranslate}} <div class="schpay_saveicon"></div></button></div>
                    }
                    @if (element.isExpanded) {
                      <div>
                        <div class="reschedule_closeicon" (click)="closeReschedule(element)"></div>
                      </div>
                    }
                  </div>
                </div>
              </td>
            </ng-container>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsMobile"  class="table-row"></tr>
            <!--Expanded row -->
            <tr *matRowDef="let row ;columns:[]"  class="expanded-row">
              @if (row.isExpanded) {
                <td [attr.colspan]="8" class="reschedule_btn_outercontainer">
                  <div class="exp_Resschedule_Container">
                    <div class="exp_Sch_ReschedulePay">{{"schedulepay.reschedulepay" | cxTranslate}}</div>
                    <div class="exp_NewPay_Date">{{"schedulepay.newpayDate" | cxTranslate}}
                      <i class="fa-regular fa-circle-question resch_pay_tooltip"><span class="resch_pay_tooltiptext">{{"schedulepay.reschpaytooltiptxt" | cxTranslate}}</span></i></div>
                      <form #dateForm="ngForm">
                        <mat-form-field class="mat-focused">
                          <input matInput maxlength="10"  (keypress)="allowNumbersOnly($event)" [matDatepicker]="picker" name="schdate" (input)="maskInputDate($event)" [(ngModel)]="dateInput" placeholder="MM/DD/YYYY" [min]="today" [max]="getFormattedDueDate(row.dueDate)" #date="ngModel" [ngClass]="date?.invalid && date?.dirty && !isFieldFocused(date) ? 'invalid-date':''">
                          <mat-datepicker-toggle matIconPrefix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                          @if (date.invalid  && date?.dirty && !isFieldFocused(date)) {
                            <span class="glyphicon glyphicon-exclamation-sign"></span>
                          }
                        </mat-form-field>
                        <div class="promptpay_text">{{"schedulepay.paymessage1" | cxTranslate}}<span>{{row.dueDate}}</span> {{"schedulepay.paymessage2" | cxTranslate}}</div>
                        @if (date?.invalid && date?.dirty && !isFieldFocused(date)) {
                          <div class="sch-pay-error-text">
                            @if (date?.errors) {
                              <p>{{"schedulepay.paymessage3" | cxTranslate}}{{row.dueDate}}</p>
                            }
                          </div>
                        }
                      </form>
                    </div>
                  </td>
                }
                @if (row.paymentStatus === 'FAILED') {
                  <td colspan="8" class="payment_failed_outersection">
                    <div class="payment-failed-section">
                      <div class="pay-fail-title"><span class="glyphicon glyphicon-exclamation-sign"></span>{{"schedulepay.payfailed" | cxTranslate}}</div>
                      <div class="pay_fail_text"><a [routerLink]="['/financial-dashboard/all-invoices']" [queryParams]="{season:row.season,invoice:row.invoiceNumber}">{{"schedulepay.viewinvoicelink" | cxTranslate}}</a>{{"schedulepay.payfailedmsg" | cxTranslate}}<br/> <a href="mailto:usainc.accountsreceivable@seqirus.com" target="_blank" class="pay_fail_maillink">usainc.accountsreceivable&#64;seqirus.com</a> or <a href="tel:866-434-1115" class="pay_fail_mobno.">866-434-1115.</a></div>
                      <button class="global_greybtn new_pay_button" [routerLink]="['/financial-dashboard/all-invoices']" [queryParams]="{season:row.season,invoice:row.invoiceNumber}">{{"schedulepay.newpaytxt" | cxTranslate}}</button>
                    </div>
                  </td>
                }
              </tr>
              <!--Header row-->
              <tr mat-header-row *matHeaderRowDef="displayedColumnsMobile" class="header-row"></tr>
            </table>
          </div>
        </div>
      } @else {
        <div class="noschpay_section">
          <div class="noschpay_subsection">
            <div class="noschpay_text">{{"schedulepay.noschedulepaytxt" | cxTranslate}}</div>
            <div class="noschpay_header">
              <div class="noschpay_subtext">{{"schedulepay.noschedulepaymsg" | cxTranslate}}</div>
            </div>
          </div>
        </div>
      }


    </div>


  </div>

  <div id="schpay_cancelmodal" class="modal fade" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <h4 class="modal-title schpay_cancelheader col-xs-11">{{"schedulepay.cancelschpay" | cxTranslate}}</h4>
          <div class="no-padding pull-right"><span class="schpaycancel_close" data-bs-dismiss="modal">×</span></div>

          <div class="col-12" class="schpay_detailsection">
            <span class="schpay_detail_text">{{"schedulepay.invoicelabel" | cxTranslate}}<span class="schpay_detail_value">#{{cancelPopupData?.invoiceNumber}}<br/></span></span>
            <span class="schpay_detail_text">{{"schedulepay.ccpaylabel" | cxTranslate}}<span class="schpay_detail_value">{{cancelPopupData?.invoiceAmount | currency:'USD':'symbol'}}<br/></span></span>
            <span class="schpay_detail_text">{{"schedulepay.paymethodlabel" | cxTranslate}}<span class="schpay_detail_value" >{{cardMap[cancelPopupData?.cardType]}} ending in {{cancelPopupData?.cardNumber.slice(-4)}}<br/></span></span>
            <span class="schpay_detail_text">{{"schedulepay.datelabel" | cxTranslate}}<span class="schpay_detail_value">{{cancelPopupData?.scheduledDate}}</span></span>
          </div>
          <div class="schpay_buttonsection">
            <button class="schpay_cancelYes global_redbtn" (click)="cancelSchedulePayment(cancelPopupData)">{{"schedulepay.yeslabel" | cxTranslate}}</button>
            <button class="schpay_cancelNo global_greybtn" data-bs-dismiss="modal">{{"schedulepay.nolabel" | cxTranslate}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div id="schpay_closeModal" class="modal fade" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <div class="modal-title" style="color: var(--blackcolor); font-size: 24px; font-family: Campton-medium; font-weight: 500; word-wrap: break-word">Discard Changes</div>
        <div class="col-xs-2 col-md-6 schpay_closebtnParent float_left"><span class="schpay_closebtn" data-dismiss="modal">×</span></div>
        <div style="width: 100%">
          Your date has not been saved. Are you sure you want to stop editing?
        </div>
        <div style="justify-content: flex-start; align-items: center; gap: 16px; display: inline-flex">
          <div style="width: 125px; padding-left: 20px; padding-right: 20px; padding-top: 8px; padding-bottom: 8px; border-radius: 2px; overflow: hidden; border: 1px #EA181B solid; justify-content: center; align-items: center; gap: 10px; display: flex">
            <div style="text-align: center; color: #EA181B; font-size: 14px; font-family: Campton-semibold; font-weight: 600; line-height: 16px;cursor:pointer; word-wrap: break-word" data-dismiss="modal" (click)="closeReschedule()">Yes, discard</div>
          </div>
          <div style="width: 125px; padding-left: 20px; padding-right: 20px; padding-top: 8px; padding-bottom: 8px; border-radius: 2px; overflow: hidden; border: 1px var(--lightgrey) solid; justify-content: center; align-items: center; gap: 10px; display: flex">
            <div style="text-align: center; color: var(--lightgrey); font-size: 14px; font-family: Campton-semibold; font-weight: 600; line-height: 16px;cursor:pointer; word-wrap: break-word"  data-dismiss="modal">No, keep editing</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->

